/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceNowCmdbScopeDetails {
    getFixupPrototypeFunction() { return ServiceNowCmdbScopeDetails.fixupPrototype; }

    static newInstance(model: Partial<ServiceNowCmdbScopeDetails>): ServiceNowCmdbScopeDetails {
        let obj = Object.assign(new ServiceNowCmdbScopeDetails(), model);
        ServiceNowCmdbScopeDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceNowCmdbScopeDetails>): ServiceNowCmdbScopeDetails {
        if (!model) return null;
        return ServiceNowCmdbScopeDetails.newInstance(<ServiceNowCmdbScopeDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceNowCmdbScopeDetails) {
        if (!obj) return;

        models.ServiceNowCmdbScopeDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceNowCmdbScopeDetails): boolean {
        Object.setPrototypeOf(obj, ServiceNowCmdbScopeDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Scope to Apply
     */
    scope: models.ServiceNowCmdbScope;

    /**
     * Master Account Id
     */
    master_account_id: string;

    /**
     * Id of the tenants that user has access to
     */
    tenant_id: string;

    /**
     * Id of the Cloud Account
     */
    cloud_account_id: string;

}
